<template>
  <BlBackdrop
    title="Create New Room"
    label="Create"
    :disabled="isDisabledSubmit"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onCreate"
  >
    <div class="px-8 flex flex-col gap-4">
      <BlInputText :input="nameInput" @changed="inputHandler" />
      <BlSelectBox
        v-if="enableBranch"
        type="branch"
        label="Branch"
        placeholder="Select branch"
        v-model="branchInput"
        :options="branchOptions"
        search
        @change="branchInput = $event"
      />
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlBackdrop from "../../BlBackdrop.vue";
import BlInputText from "../../BlInputText.vue";
import BlSelectBox from "../../BlSelectBox.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "NewRoomModal",
  components: {
    BlBackdrop,
    BlInputText,
    BlSelectBox,
    BlInputButton
  },
  data() {
    return {
      submitLoading: false,
      nameInput: {
        label: "Room name",
        asterisk: true,
        placeholder: "Type the name",
        model: ""
      },
      branchInput: []
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter", "branches"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    branchOptions() {
      return this.branches.map(i => ({
        value: i.id,
        label: i.name,
        color: i.color,
        backgroundColor: i.background_color
      }));
    },
    isDisabledSubmit() {
      if (this.submitLoading) return true;
      if (!this.nameInput.model) return true;
      return false;
    }
  },
  methods: {
    ...mapActions(["createRoom"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    onCreate() {
      const data = {
        room: {
          name: this.nameInput.model,
          branch_id: this.branchInput
        }
      };
      this.submitLoading = true;
      this.createRoom(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) {
          return;
        }
        this.$emit("close-modal");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/availabilities/room/NewRoomModal.vue